import React, { useEffect, useState } from 'react';
import { log } from '@economic/react-app';

import internalApiClient from '../util/api/internalApiClient';

export function usePostQuery<T>(url: string, postData: object | number | string, skip?: boolean) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [data, setData] = useState<T | undefined>();

    const post = async url => {
        setLoading(true);

        return internalApiClient
            .post(url, postData, { headers: { 'Content-Type': 'application/json' } })
            .then(r => {
                setData(r.data);
            })
            .catch(error => {
                setError(error);
                if (error && error.response && error.response.status >= 500) {
                    log.error(error);
                }
            })
            .then(() => setLoading(false));
    };

    const repost = React.useCallback(() => post(url), [url, skip]);

    useEffect(() => {
        if (skip === true) {
            return;
        }

        post(url);

        return () => {
            setLoading(true);
            setData(undefined);
            setError(undefined);
        };
    }, [url, skip]);

    return {
        loading,
        data,
        error,
        repost,
    };
}
